import React from "react";
import DetailedAlbumItem from "./DetailedAlbumItem";
import SquaredAlbumItem from "./SquaredAlbumItem";
import { useDispatch} from "react-redux";
import { clickAlbumItem } from "../../actions/clickActions";
import { ALBUM_LAYOUTS } from "../../utils/constants/enumConstants";

const AlbumItem = ({album, layout}) => {
    const dispatch = useDispatch();
    
    const onClickAlbum = (e) => dispatch(clickAlbumItem(album, e));

    return (
        <div>
        {
            layout === ALBUM_LAYOUTS.list ?
            <DetailedAlbumItem album={album} onClick={onClickAlbum} /> :
            <SquaredAlbumItem album={album} onClick={onClickAlbum} />
        }
        </div>
    )
}

export default React.memo(AlbumItem);